module.exports = __webpack_public_path__ + "static/saltaire@fiferries.bed624c0.jpg";